/*LIBRARY*/
import React, { useCallback } from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import { set_value_properties } from "../../App/actions/propertiesActions";
import { status_action } from "../../App/actions/mapActions";
import { status_toolbox } from "../../App/actions/toolboxActions";

/*PICTURE*/

/*FUNCTION*/
import { generate_paint } from "../../Functions/map_style/generate_paint";

/*FUNCTION*/
import dict from "../../Data/dict.json";
import ProgressBarButton from "../reuseable/ProgressBarButton";

/*CONST*/

const RANGE_NUMBER_STEP = ({
  auth,
  properties,
  set_value_properties,
  status_action,
  status_toolbox,
}) => {
  const on_change = useCallback(
    (e) => {
      const { name, type } = e.target;
      let { value } = e.target;

      if (type === "number" || type === "range") {
        value = Number(value);
      }

      const { style_parameter } = properties;

      const new_style_parameter = {
        ...style_parameter,
        [name]: value,
      };

      set_value_properties({
        key: "style_parameter",
        value: new_style_parameter,
      });
    },
    [properties, set_value_properties],
  );

  const on_regenerate_paint = useCallback(() => {
    const { style_parameter, paint_object_edited } = properties;
    const style_parameter_new = {
      ...style_parameter,
      paint_object_edited,
    };

    const paint_object_new = generate_paint(style_parameter_new);

    set_value_properties({
      key: "paint_object_edited",
      value: paint_object_new,
    });

    status_action();
    status_toolbox();
  }, [properties, set_value_properties, status_action, status_toolbox]);

  //local storage
  const language = localStorage?.language || auth.language;

  //global props
  const { style_parameter, paint_object_edited } = properties;

  //content
  const { style_type, min, max, steps } = style_parameter;

  let color_key;
  if (style_type === "circle") {
    color_key = "circle-color";
  } else if (style_type === "line") {
    color_key = "line-color";
  } else if (style_type === "fill") {
    color_key = "fill-color";
  }

  let rows = [];
  let array_number_step = paint_object_edited?.[color_key] || [];

  array_number_step = array_number_step.slice(2, array_number_step.length);

  const test_2 = " - ";
  const test_mid_2 = " < ";
  const test_big_2 = "≥ ";

  array_number_step.forEach((item, idx) => {
    if (idx % 2 === 1) {
      rows.push(
        <div
          key={idx}
          style={{ display: "flex", padding: "2px 5px", gap: "15px" }}
        >
          <div
            style={{
              width: "25px",
              height: "25px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                backgroundColor: array_number_step?.[idx - 1], // Color is at the next index
                width: "20px",
                height: "20px",
                borderRadius: "100%",
              }}
            />
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "start",
              alignItems: "center",
            }}
          >
            <p className="text_right">
              {array_number_step?.[idx - 2] !== undefined
                ? `${array_number_step?.[idx - 2]}${test_2}`
                : test_mid_2}
              {item}
            </p>
          </div>
        </div>,
      );
    }
  });

  if (array_number_step?.length > 0) {
    rows.push(
      <div
        key="last"
        style={{ display: "flex", padding: "2px 5px", gap: "15px" }}
      >
        <div
          style={{
            width: "25px",
            height: "25px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              backgroundColor:
                array_number_step?.[array_number_step.length - 1],
              width: "20px",
              height: "20px",
              borderRadius: "100%",
            }}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
          }}
        >
          <p className="text_right">
            {test_big_2}
            {array_number_step?.[array_number_step.length - 2]}
          </p>
        </div>
      </div>,
    );
  }

  // Injecting CSS for the range slider (since inline styles can't hit pseudo-elements)
  const rangeSliderCSS = `
    .custom-range {
      -webkit-appearance: none;
      width: 100%;
      background: transparent;
    }
    /* Pointer / Thumb styling */
    .custom-range::-webkit-slider-thumb {
      -webkit-appearance: none;
      height: 16px;
      width: 16px;
      border-radius: 50%;
      background: #006C3D; /* Change pointer color here */
      cursor: pointer;
      margin-top: -6px; /* Adjust to center vertically on the track */
    }
    /* Track styling */
    .custom-range::-webkit-slider-runnable-track {
      width: 100%;
      height: 4px;
      cursor: pointer;
      background: #80B520; /* Change track color here */
      border-radius: 2px;
    }
    /* Firefox support */
    .custom-range::-moz-range-thumb {
      height: 16px;
      width: 16px;
      border-radius: 50%;
      background: #006C3D;
      cursor: pointer;
      border: none;
    }
    .custom-range::-moz-range-track {
      width: 100%;
      height: 4px;
      cursor: pointer;
      background: #80B520;
      border-radius: 2px;
    }
  `;

  return (
    /* Added height: '100%' and overflow: 'hidden' to prevent parent blowout */
    <main
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        height: "100%",
        overflow: "hidden",
      }}
    >
      <style>{rangeSliderCSS}</style>

      <section
        style={{ display: "flex", flexDirection: "column", gap: "20px" }}
      >
        <div>
          <p className="text_medium" style={{ marginBottom: "15px" }}>
            {dict?.["Ganti jumlah range"]?.[language]}
          </p>
          {/* Changed this to type="range" and added className="custom-range" to showcase the slider */}
          <input
            className="margin_bottom custom-range"
            type="range"
            name="steps"
            value={steps}
            min="1"
            max="10"
            onChange={on_change}
            data-mapid="numberRange"
          />
        </div>
        <div style={{ display: "flex", gap: "8px" }}>
          <div>
            <p className="text_medium" style={{ marginBottom: "15px" }}>
              {dict?.["Change min"]?.[language]}
            </p>
            <input
              className="margin_bottom"
              type="number"
              name="min"
              value={min}
              onChange={on_change}
              data-mapid="numberMin"
            />
          </div>
          <div>
            <p className="text_medium" style={{ marginBottom: "15px" }}>
              {dict?.["Change max"]?.[language]}
            </p>
            <input
              className="margin_bottom"
              type="number"
              name="max"
              value={max}
              onChange={on_change}
              data-mapid="numberMax"
            />
          </div>
        </div>
        <ProgressBarButton onClick={on_regenerate_paint}>
          {dict?.["Parameter replacement process"]?.[language]}
        </ProgressBarButton>
      </section>

      {/* Added flex: 1 and minHeight: 0 to this section to enable dynamic scrolling */}
      <section
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          minHeight: 0,
        }}
      >
        <div
          style={{
            backgroundColor: "#80B5201A",
            borderRadius: "10px",
            padding: "8px 16px",
            width: "fit-content",
            marginBottom: "10px",
            flexShrink: 0, // Prevent the header from shrinking
          }}
        >
          <h2 style={{ color: "#006C3D", fontSize: "12px", fontWeight: 600 }}>
            {dict?.["Legend"]?.[language]}
          </h2>
        </div>

        {/* Replaced fixed maxHeight with flex: 1 and overflowY: "auto" */}
        <div style={{ flex: 1, overflowY: "auto" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              backgroundColor: "#FAFAFA",
              padding: "15px",
              border: "1px solid #ABABAB4D",
              borderRadius: "10px",
            }}
          >
            {rows}
          </div>
        </div>
      </section>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  properties: state.properties,
});

export default connect(mapStateToProps, {
  set_value_properties,
  status_action,
  status_toolbox,
})(RANGE_NUMBER_STEP);
